import { FC } from 'react';
import { RiskEntitiesOverview } from '../api/types/RiskEntities';
import { SEVERITIES_INFO } from '../../../consts/Severity';
import { bigNumberToText } from '../../../components/utils';

interface Props {
    riskEntitiesOverview: RiskEntitiesOverview;
}

const RiskEntitiesBarGraph: FC<Props> = ({ riskEntitiesOverview }) => {
    const total: number = Object.values(riskEntitiesOverview).reduce((acc, curr) => acc + curr, 0);

    return (
        <div className="w-full h-full flex flex-col gap-2">
            <div className="h-4 flex items-center justify-between">
                <div className="text-12 font-sf">Total</div>
                <div className="text-13 font-bold font-sf-poppins">{bigNumberToText(total)}</div>
            </div>
            <div className="w-full h-1 flex items-center gap-[2px]">
                {Object.entries(riskEntitiesOverview).map(([key, value]) => (
                    <div
                        key={key}
                        style={{ width: `${(value / total) * 100}%` }}
                        className={`bg-${SEVERITIES_INFO[key].color} h-full first:rounded-l-[2px] last:rounded-r-[2px]`}
                    />
                ))}
            </div>
        </div>
    );
};

export default RiskEntitiesBarGraph;
